import React, {Component} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import queryString from "query-string";

class OrgChart extends Component {
    getPersonLink = (tabNum, personName) => {
        if (!tabNum)
            return null;

        return <Link to={{
            pathname: '/Profile',
            search: queryString.stringify({TabNum: tabNum})
        }}>{!!personName ? personName : "?"}</Link>
    };

    renderPersonInfo = (p) => {
        let className = "";
        if (p.TabNum === this.props.tabNum) {
            className += "ml-2 pr-2 orgChart-selectedPerson";
        }

        let personName = !p.AllowViewInfo ? p.FIO : this.getPersonLink(p.TabNum, p.FIO);

        return (
            <span className={className}>
                <span className="ml-2 font-weight-bold">
                    {personName}
                </span>
                <span className="ml-2 text-grey">{p.JobTitle}</span>
            </span>
        );
    };

    renderBoss = (p) => {
        return (
            <div key={p.TabNum} className="d-flex align-items-center orgChart-personContainer">
                <div className="orgChart-arrowContainer">
                    <i className="zmdi zmdi-long-arrow-up"></i>
                </div>
                {this.renderPersonInfo(p)}
            </div>
        );
    };

    renderSub = (p, addClass = " ml-1") => {
        return (
            <div key={p.TabNum} className={"orgChart-personContainer" + addClass}>
                <div className="orgChart-line-v"></div>
                <div className="orgChart-line-h-container">
                    <div className="orgChart-line-h"></div>
                </div>
                {this.renderPersonInfo(p)}
            </div>
        );
    };

    renderPerson = (p, subArr) => {
        if (subArr.length === 0) {
            return this.renderSub(p);
        }
        return (
            <>
                <div className="orgChart-personContainer">
                    <button type="button" className="btn p-0" id="orgChart_collapseButton"
                            data-toggle="collapse" data-target="#orhChart_subContainer" aria-expanded={true}>
                        <i id="orgChart_collapsed" className="zmdi zmdi-plus" />
                        <i id="orgChart_expanded" className="zmdi zmdi-minus" />
                    </button>
                    {this.renderPersonInfo(p)}
                </div>
                <div id="orhChart_subContainer" className="collapse show">
                    {subArr.map(s => this.renderSub(s, " ml-4"))}
                </div>
            </>
        );

    };

    render() {
        if (!this.props.dataItem.isInitialized) {
            return null;
        }

        let data = this.props.dataItem.dataTable();
        if (data.length === 0) {
            return null;
        }

        let person = data.filter(p => p.TabNum === this.props.tabNum)[0];
        let bossArr = data.filter(p => p.PersLevel < person.PersLevel);
        let subArr = data.filter(p => p.PersLevel > person.PersLevel);
        let collArr = data.filter(p => p.PersLevel === person.PersLevel && p.TabNum !== person.TabNum);

        return (
            <>
                {bossArr.map(p => this.renderBoss(p))}
                {this.renderPerson(person, subArr)}
                {collArr.map(p => this.renderSub(p))}
            </>
        );

    }
}

OrgChart.propTypes = {
    dataItem: PropTypes.object.isRequired,
    tabNum: PropTypes.string.isRequired
};

OrgChart.defaultProps = {};

export default OrgChart;